import React from 'react';
import PropTypes from 'prop-types';
import urlJoin from 'url-join';
import { getIconUrl } from '.';
import { Link } from 'react-router-dom';
import VideoStatsString from './VideoStatsString';


const TopicNavActiveItem = ({ mobileUi, videoStats, baseUrl, uid, name, slug, longDescription, icon, color, subtopics, activeIssue }) => {
  const linkHref = urlJoin(baseUrl, slug, mobileUi ? '?showOverlay=true' : '');
  const { iconReverse } = getIconUrl(icon);
  return (
    <div className="topic-tree-nav-item-active">
      <div className="icon" style={{ backgroundColor: color }}>
        <img src={iconReverse} alt="" />
      </div>
      <h4 className="heading-display text-uppercase">
        <Link to={linkHref}>{name}</Link>
      </h4>
      {!activeIssue && !mobileUi
        ? <div className="caption mb-3" dangerouslySetInnerHTML={{ __html: longDescription }} />
        : <div style={{ height: 20 }} />
      }
      {mobileUi ? (
        <div className="topic-tree-nav-item-issue">
          <header>
            <div className="icon" style={{ backgroundColor: color }} />
            <h6><Link to={linkHref} className="text-uppercase">Overview</Link></h6>
          </header>
        </div>
      ) : null}
      {subtopics.map(({ uid, name, slug: issueSlug, description }) => {
        const linkHref = urlJoin(baseUrl, slug, issueSlug, mobileUi ? '?showOverlay=true' : '');
        const isActive = activeIssue && activeIssue.slug === issueSlug;
        return (
          <div key={issueSlug} className="topic-tree-nav-item-issue">
            <header>
              <div className="icon" style={{ backgroundColor: color }} />
              <h6 className="mr-1"><Link to={linkHref}>{name}</Link></h6>
              <VideoStatsString videoStats={videoStats} uid={uid} />
            </header>
            {isActive && !mobileUi ? <div className="issue-description caption pb-2" dangerouslySetInnerHTML={{ __html: description }} /> : null}
          </div>
        );
      })}
    </div>
  );
};

TopicNavActiveItem.propTypes = {
  mobileUi: PropTypes.bool,
  name: PropTypes.string,
  slug: PropTypes.string,
  longDescription: PropTypes.string,
  shortDescription: PropTypes.string,
  icon: PropTypes.string,
  iconReverse: PropTypes.string,
  color: PropTypes.string,
  media: PropTypes.arrayOf(PropTypes.object),
  subtopics: PropTypes.arrayOf(PropTypes.object),
  activeIssue: PropTypes.object,
};

export default TopicNavActiveItem;



// WEBPACK FOOTER //
// ./src/components/TopicTree/TopicNavActiveItem.js